import { boot } from '@dazn/bootstrap-lib';

export const getLivingRoomAttributes = (
    deviceMetadata: boot.device.DeviceMetadata,
    manufacturer: string,
): boot.fflag.LivingRoomAttributes => {
    if (!deviceMetadata) {
        return {};
    }

    // remove undefined values from output using JSON methods
    return JSON.parse(
        JSON.stringify({
            FirmwareVersion: deviceMetadata.firmwareVersion,
            Manufacturer: manufacturer,
            DeviceModel: deviceMetadata.model,
            DeviceBrand: deviceMetadata.brand,
            DeviceType: deviceMetadata.type,
            OsName: deviceMetadata.osName,
            OsVersion: deviceMetadata.osVersion,
        }),
    );
};
